import { useQuery } from "@tanstack/react-query";
import { MediumService } from "../../services";
import { asQuery } from "../../services/common";
import { ONE_HOUR } from "./shared";

// All mediums (with populated categoryId).
export function useMediums() {
  return useQuery({
    queryKey: ["mediums", "all"],
    queryFn: () => asQuery<any[]>(MediumService.all({ keyword: "" })),
    staleTime: ONE_HOUR,
  });
}

// Mediums for a single category — paused until a categoryId is provided.
export function useMediumsByCategory(categoryId?: string) {
  return useQuery({
    queryKey: ["mediums", "by-category", categoryId],
    queryFn: () =>
      asQuery<any[]>(MediumService.getByCategory({ categoryId, keyword: "" })),
    enabled: !!categoryId,
    staleTime: ONE_HOUR,
  });
}

// A single medium by id (token-gated) — paused until an id is provided.
export function useMedium(id?: string, token?: string) {
  return useQuery({
    queryKey: ["mediums", id],
    queryFn: () =>
      asQuery<any>(MediumService.getById(id as string, token as string)),
    enabled: !!id && !!token,
    staleTime: ONE_HOUR,
  });
}
